import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Box,
    Typography,
    Alert,
    CircularProgress
} from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";

const DeleteExerciseDialog = ({
    open,
    onClose,
    onConfirm,
    exercise,
    isLoading = false
}) => {
    return (
        <Dialog
            open={open}
            onClose={isLoading ? undefined : onClose}
            aria-labelledby="delete-exercise-dialog-title"
            aria-describedby="delete-exercise-dialog-description"
            disableEscapeKeyDown={isLoading}
            PaperProps={{
                sx: {
                    borderRadius: "12px",
                    minWidth: "360px",
                    direction: "rtl",
                    position: "relative"
                }
            }}
        >
            <DialogContent sx={{ textAlign: "center", padding: "32px 24px 16px", opacity: isLoading ? 0.6 : 1 }}>
                {isLoading && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                            zIndex: 1,
                            borderRadius: "12px"
                        }}
                    >
                        <CircularProgress size={40} sx={{ color: "#EF4444" }} />
                    </Box>
                )}
                <Box
                    sx={{
                        width: 64,
                        height: 64,
                        borderRadius: "50%",
                        backgroundColor: "#FEE2E2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 16px"
                    }}
                >
                    <WarningIcon sx={{ fontSize: 32, color: "#EF4444" }} />
                </Box>
                <DialogTitle
                    id="delete-exercise-dialog-title"
                    sx={{
                        padding: 0,
                        marginBottom: "8px",
                        fontWeight: 600,
                        fontSize: "18px",
                        color: "#1E293B",
                        fontFamily: '"Heebo", "Roboto", sans-serif'
                    }}
                >
                    {"האם אתה בטוח?"}
                </DialogTitle>
                <DialogContentText
                    id="delete-exercise-dialog-description"
                    sx={{
                        color: "#64748B",
                        fontSize: "14px",
                        fontFamily: '"Heebo", "Roboto", sans-serif'
                    }}
                >
                    {exercise?.nameHeb || exercise?.name
                        ? `אתה עומד למחוק את התרגיל "${exercise.nameHeb || exercise.name}".`
                        : "אתה עומד למחוק את התרגיל הזה."
                    }
                </DialogContentText>

                {exercise?.systemResource && (
                    <Alert
                        severity="warning"
                        sx={{
                            mt: 2,
                            textAlign: "right",
                            '& .MuiAlert-message': {
                                width: '100%'
                            }
                        }}
                    >
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            שים לב: זהו תרגיל מערכת
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: '12px', mt: 0.5 }}>
                            מחיקתו תשפיע על כל החברות במערכת
                        </Typography>
                    </Alert>
                )}

                <Typography
                    variant="body2"
                    sx={{
                        mt: 2,
                        color: "#94A3B8",
                        fontSize: "12px"
                    }}
                >
                    פעולה זו תמחק את כל היסטוריית האימונים והנתונים הקשורים לתרגיל זה.
                    פעולה זו לא ניתנת לביטול.
                </Typography>
            </DialogContent>
            <DialogActions
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "16px 24px 24px",
                    gap: 1
                }}
            >
                <Button
                    variant="outlined"
                    onClick={onClose}
                    disabled={isLoading}
                    sx={{
                        borderColor: "#E2E8F0",
                        color: "#64748B",
                        fontFamily: '"Heebo", "Roboto", sans-serif',
                        "&:hover": {
                            borderColor: "#CBD5E1",
                            backgroundColor: "#F8FAFC"
                        }
                    }}
                >
                    ביטול
                </Button>
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    disabled={isLoading}
                    startIcon={isLoading ? <CircularProgress size={16} sx={{ color: "white" }} /> : null}
                    sx={{
                        backgroundColor: "#EF4444",
                        fontFamily: '"Heebo", "Roboto", sans-serif',
                        minWidth: "80px",
                        "&:hover": {
                            backgroundColor: "#DC2626"
                        },
                        "&:disabled": {
                            backgroundColor: "#F87171",
                            color: "white"
                        }
                    }}
                >
                    {isLoading ? 'מוחק...' : 'מחק'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteExerciseDialog;
